module.exports = __webpack_public_path__ + "static/media/head_hunter.301ff552.png";